import React, { useState, useEffect, useRef } from 'react';
import "./App.css";
import "./index.css";
import TandC from "./component/TandC";
import PandP from "./component/PandP";
import Modal from "./component/modal";
import StoreModal from "./component/storeModal";

const buyerTestimonials = [
  { text: "Pairwota has completely changed how we handle water at home. No more last-minute runs to the store!", author: "Sarah O.", location: "Lagos" },
  { text: "The recurring delivery feature is a lifesaver. I never have to worry about running out of clean water again.", author: "David A.", location: "Abuja" },
  { text: "Verified producers give me peace of mind. Knowing my water is clean is everything.", author: "Amina K.", location: "Lagos" },
  { text: "The app is so easy to use. Two clicks and water is at my doorstep. Highly recommend!", author: "John M.", location: "Port Harcourt" },
  { text: "Love the transparent pricing. No hidden fees, just pure water and great service.", author: "Chioma E.", location: "Ibadan" },
  { text: "Customer support is top-notch. They really care about the hydration experience.", author: "Michael B.", location: "Lagos" },
  { text: "I use it for my office and home. One app handles everything perfectly.", author: "Zainab R.", location: "Abuja" },
  { text: "Fastest delivery I've ever experienced. Usually arrives within 30 minutes!", author: "Emmanuel T.", location: "Lagos" },
];

const producerTestimonials = [
  { text: "The digital fleet management transformed our operations. We've seen a 40% increase in efficiency.", author: "Lekan S.", company: "Global Springs" },
  { text: "Real-time routing has significantly reduced our delivery mistakes and customer complaints.", author: "Funke B.", company: "AquaPure" },
  { text: "Automated invoicing saved us hours of manual work every week. It's a game changer.", author: "Ibrahim O.", company: "Crystal Clear" },
  { text: "The analytics dashboard helps us understand our peak times and optimize our runs.", author: "Nelson E.", company: "PureDrops" },
  { text: "Customer retention analytics showed us exactly where we were losing people.", author: "Adewale J.", company: "BlueWave Water" },
  { text: "Managing 20 drivers used to be a nightmare. Now I do it all from one screen with ease.", author: "Tunde V.", company: "Peak Hydration" },
  { text: "The automated payouts ensure we get paid on time, every time. No more chasing debtors!", author: "Bose A.", company: "Oasis Springs" },
  { text: "Transitioning from WhatsApp to Pairwota's portal was the best business decision we made.", author: "Chidi N.", company: "Zenith Water" },
];

export default function App() {
  const [nav, setNav] = useState("home");
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [storeModal, setStoreModal] = useState(false);
  const scrollContainerRef = useRef(null);

  const handleScroll = (direction) => {
    if (scrollContainerRef.current) {
      const { current } = scrollContainerRef;
      const scrollAmount = current.offsetWidth * 0.8;
      if (direction === 'left') {
        current.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      } else {
        current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      }
    }
  };

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: "0px 0px -50px 0px"
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add("active");
        }
      });
    }, observerOptions);

    const revealElements = document.querySelectorAll(".reveal");
    revealElements.forEach(el => observer.observe(el));

    const timer = setTimeout(() => setLoading(false), 800);
    window.scrollTo(0, 0);

    return () => {
      clearTimeout(timer);
      revealElements.forEach(el => observer.unobserve(el));
    };
  }, [nav]);

  const Header = () => (
    <header className="fixed top-0 w-full z-50 bg-white/70 backdrop-blur-xl border-b border-white/20 transition-all duration-300 shadow-sm">
      <nav className="flex justify-between items-center px-6 h-20 w-full max-w-7xl mx-auto">
        <div className="flex items-center gap-3 cursor-pointer" onClick={() => setNav('home')}>
          <div className="w-10 h-10 bg-primary/10 rounded-xl flex items-center justify-center blob-shape overflow-hidden">
            <img src="https://storage.googleapis.com/wota_public/pairwota%20logo%20png.png" alt="WOTA Logo" className="w-full h-full object-cover scale-110" />
          </div>
          <span className="text-primary font-headline font-bold text-2xl tracking-tighter">Pairwota</span>
        </div>
        <div className="hidden md:flex items-center gap-8 bg-slate-50/50 backdrop-blur-md px-8 py-3 rounded-full border border-slate-200/50">
          <span onClick={() => setNav('home')} className="cursor-pointer text-slate-800 hover:text-primary font-semibold text-sm transition-colors">Home</span>
          <a href="#how-it-works" className="text-slate-500 hover:text-primary transition-colors font-semibold text-sm">How it works</a>
          <a href="#sellers" className="text-slate-500 hover:text-primary transition-colors font-semibold text-sm">For Sellers</a>
          <a href="#contact" className="text-slate-500 hover:text-primary transition-colors font-semibold text-sm">Contact</a>
        </div>
        <div className="flex items-center gap-4">
          <button onClick={() => setStoreModal(true)} className="px-6 py-3 rounded-full bg-primary text-white font-bold text-sm hover:shadow-lg hover:-translate-y-0.5 transition-all shadow-primary/20 blob-shape">
            Get the App
          </button>
        </div>
      </nav>
    </header>
  );

  const Footer = () => (
    <footer id="contact" className="bg-slate-900 pt-32 pb-12 relative overflow-hidden">
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary/10 rounded-full blur-3xl mix-blend-screen opacity-50 blob-shape"></div>
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-16 mb-24">
          <div className="space-y-8">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-white/10 rounded-xl flex items-center justify-center blob-shape">
                  <img src="https://storage.googleapis.com/wota_public/pairwota%20logo%20png.png" alt="WOTA Logo" className="w-full h-full object-cover" />
              </div>
              <span className="text-white font-headline font-bold text-2xl tracking-tight">Pairwota</span>
            </div>
            <p className="text-slate-400 leading-relaxed text-sm">Nigeria's smartest water delivery network. Pure hydration, zero stress.</p>
            <div className="flex gap-4">
              <a className="w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-white hover:bg-primary transition-colors bubble" href="mailto:support@pairwota.com">
                <span className="material-symbols-outlined text-xl">mail</span>
              </a>
              <a className="w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-white hover:bg-primary transition-colors bubble" href="https://twitter.com/WorldofThirst" target="_blank" rel="noreferrer">
                <span className="material-symbols-outlined text-xl">share</span>
              </a>
            </div>
          </div>
          <div>
            <h5 className="font-headline font-bold text-white mb-6">Explore</h5>
            <ul className="space-y-4 text-slate-400 text-sm">
              <li><a href="#how-it-works" className="cursor-pointer hover:text-white transition-colors">How it works</a></li>
              <li><a href="#sellers" className="cursor-pointer hover:text-white transition-colors">Sellers Portal</a></li>
              <li><span className="cursor-pointer hover:text-white transition-colors">Safety Standards</span></li>
              <li><span className="cursor-pointer hover:text-white transition-colors">Locations</span></li>
            </ul>
          </div>
          <div>
            <h5 className="font-headline font-bold text-white mb-6">Legal</h5>
            <ul className="space-y-4 text-slate-400 text-sm">
              <li><span onClick={() => setNav('pandp')} className="cursor-pointer hover:text-white transition-colors">Privacy Policy</span></li>
              <li><span onClick={() => setNav('tandc')} className="cursor-pointer hover:text-white transition-colors">Terms of Service</span></li>
              <li><span className="cursor-pointer hover:text-white transition-colors">Vendor Agreement</span></li>
            </ul>
          </div>
          <div>
            <h5 className="font-headline font-bold text-white mb-6">Contact</h5>
            <ul className="space-y-4 text-slate-400 text-sm">
              <li className="flex items-center gap-3">
                <span className="material-symbols-outlined text-sm text-primary">mail</span>
                support@pairwota.com
              </li>
              <li className="flex items-center gap-3">
                <span className="material-symbols-outlined text-sm text-primary">call</span>
                +234 (0) 800-WATER-NG
              </li>
              <li className="flex items-center gap-3">
                <span className="material-symbols-outlined text-sm text-primary">location_on</span>
                Victoria Island, Lagos
              </li>
            </ul>
          </div>
        </div>
        <div className="pt-10 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-xs">© {new Date().getFullYear()} Pairwota Technologies Ltd. All rights reserved.</p>
          <div className="flex gap-8 text-xs font-semibold text-slate-500">
            <a href="https://twitter.com/WorldofThirst" target="_blank" rel="noreferrer" className="hover:text-white transition-colors">Twitter</a>
            <a href="https://www.linkedin.com/company/worldofthirst/" target="_blank" rel="noreferrer" className="hover:text-white transition-colors">LinkedIn</a>
            <a href="https://www.instagram.com/worldofthirstapp/" target="_blank" rel="noreferrer" className="hover:text-white transition-colors">Instagram</a>
          </div>
        </div>
      </div>
    </footer>
  );

  const Home = () => (
    <main className="bg-slate-50 selection:bg-primary/20">
      {/* Hero Section */}
      <section id="home" className="relative pt-40 pb-24 md:pt-56 md:pb-40 overflow-hidden bg-white/40">
        
        {/* Liquid Glass Background Elements */}
        <div className="absolute top-[-10%] right-[-5%] w-[400px] h-[400px] md:w-[600px] md:h-[600px] bg-blue-400/20 rounded-full blur-3xl mix-blend-multiply opacity-70 blob-shape"></div>
        <div className="absolute bottom-[-10%] left-[-10%] w-[300px] h-[300px] md:w-[500px] md:h-[500px] bg-orange-400/10 rounded-full blur-3xl mix-blend-multiply opacity-60 blob-shape" style={{animationDelay: '2s'}}></div>

        <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-20 items-center relative z-10">
          <div className="space-y-8 reveal">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-blue-50/80 backdrop-blur-sm border border-blue-100 text-primary text-xs font-bold shadow-sm">
              <span className="relative flex h-2.5 w-2.5">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-primary"></span>
              </span>
              Now live in Lagos!
            </div>
            <h1 className="text-6xl md:text-8xl font-headline font-extrabold text-slate-900 leading-[0.95] tracking-tight">
              Tap.<br/> Drink.<br/>  <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-blue-400">Repeat.</span>
            </h1>
            <p className="text-xl text-slate-600 leading-relaxed max-w-lg">
              Nigeria's smartest water delivery network. Connect with trusted sellers near you and track your delivery live. <b>Zero stress, pure hydration.</b>
            </p>
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <button onClick={() => setStoreModal(true)} className="bg-primary text-white px-8 py-4 rounded-full font-bold text-lg shadow-xl shadow-primary/30 hover:shadow-2xl hover:-translate-y-1 transition-all flex items-center justify-center gap-3 blob-shape">
                <span className="material-symbols-outlined">water_drop</span>
                Get Water Now
              </button>
              <button onClick={() => setModal(true)} className="bg-white/80 backdrop-blur-md border border-slate-200 text-slate-700 px-8 py-4 rounded-full font-bold text-lg hover:border-primary hover:text-primary transition-all flex items-center justify-center gap-3">
                <span className="material-symbols-outlined">storefront</span>
                Become a Seller
              </button>
            </div>
            
            <div className="pt-8 flex items-center gap-4 text-sm font-semibold text-slate-500">
              <div className="flex -space-x-3">
                 {[1,2,3,4].map((i) => (
                    <img key={i} className="w-10 h-10 rounded-full border-2 border-white object-cover" src={`https://storage.googleapis.com/wota_public/pairwota%20logo%20png.png`} alt="user" />
                 ))}
              </div>
              <p>Trusted by <span className="text-primary font-bold">10,000+</span> thirsty Nigerians.</p>
            </div>
          </div>
          
          <div className="relative reveal" style={{ transitionDelay: '0.2s' }}>
            {/* Glass Container for Hero Image */}
            <div className="relative z-10 rounded-[2.5rem] overflow-hidden glass-effect border border-white/40 shadow-2xl p-3">
               <div className="rounded-[2rem] overflow-hidden aspect-[4/5] relative bg-slate-100 flex items-center justify-center">
                 <img alt="Buyer App Screen" className="w-full h-auto object-cover scale-105 hover:scale-100 transition-transform duration-700" src="https://storage.googleapis.com/wota_public/app_shot1.jpg"/>
                 <div className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-slate-900/60 to-transparent"></div>
                 
                 <div className="absolute bottom-6 left-6 right-6 backdrop-blur-md bg-white/20 border border-white/20 p-4 rounded-2xl flex items-center justify-between text-white">
                    <div>
                      <div className="text-xs font-semibold opacity-80">ETA</div>
                      <div className="font-bold text-lg">14 Mins Away</div>
                    </div>
                    <div className="w-12 h-12 bg-white text-primary rounded-full flex items-center justify-center blob-shape">
                      <span className="material-symbols-outlined">local_shipping</span>
                    </div>
                 </div>
               </div>
            </div>
            
            {/* Floating Review Badge */}
            <div className="absolute -top-6 -right-6 z-20 backdrop-blur-xl bg-white/80 p-5 rounded-2xl shadow-xl border border-white/50 animate-bounce" style={{animationDuration: '3s'}}>
              <div className="flex gap-1 text-[#F97316] mb-2">
                {[...Array(5)].map((_, i) => (
                  <span key={i} className="material-symbols-outlined text-sm" style={{ fontVariationSettings: "'FILL' 1" }}>star</span>
                ))}
              </div>
              <div className="font-bold text-slate-800 text-sm">"Super fast delivery!"</div>
              <div className="text-xs text-slate-500 mt-1">— Adeola, Surulere</div>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section id="how-it-works" className="py-32 bg-white relative">
        <div className="absolute left-0 top-1/4 w-[300px] h-[300px] bg-primary/5 rounded-full blur-3xl blob-shape"></div>
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center max-w-2xl mx-auto mb-20 space-y-4 reveal">
            <h2 className="text-primary font-bold tracking-widest uppercase text-xs">How it Works</h2>
            <h3 className="text-4xl md:text-5xl font-headline font-extrabold text-slate-900 tracking-tight">Water at the <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-orange-400">Speed of Life.</span></h3>
            <p className="text-slate-500 text-lg">Focus on your grind. We handle the heavy lifting. Three simple steps to total hydration.</p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8">
            {[
              { icon: 'location_on', title: '1. Find Sellers', desc: 'Open the app and instantly see verified water vendors in your immediate area.' },
              { icon: 'touch_app', title: '2. Tap to Order', desc: 'Choose your preferred size (bottles, dispensers, or tankers) and pay securely.' },
              { icon: 'bolt', title: '3. Delivered Fast', desc: 'Track your delivery rider in real-time. Pure water arrives at your doorstep in minutes.' }
            ].map((item, i) => (
              <div key={i} className="group glass-effect bg-slate-50/50 rounded-3xl p-10 hover:bg-white hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 border border-slate-100 reveal" style={{ transitionDelay: `${i * 0.1}s` }}>
                <div className="w-16 h-16 rounded-2xl bg-blue-100 text-primary flex items-center justify-center mb-8 group-hover:scale-110 transition-transform blob-shape">
                  <span className="material-symbols-outlined text-3xl">{item.icon}</span>
                </div>
                <h4 className="text-2xl font-bold text-slate-900 mb-4">{item.title}</h4>
                <p className="text-slate-600 leading-relaxed font-medium">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Sizes Section */}
      <section className="py-24 bg-slate-900 text-white relative overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-primary/20 via-slate-900 to-slate-900"></div>
        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <div className="flex flex-col md:flex-row justify-between items-end mb-16 gap-8 reveal">
            <div className="space-y-4">
              <h3 className="text-4xl md:text-5xl font-headline font-extrabold tracking-tight">However You Hydrate,<br/> We Deliver.</h3>
              <p className="text-slate-400 text-lg max-w-xl">From personal bottles to estate tankers, we've got your size covered.</p>
            </div>
            <div className="flex gap-4">
              <button onClick={() => handleScroll('left')} className="p-4 rounded-full bg-slate-800 hover:bg-slate-700 transition-colors">
                <span className="material-symbols-outlined">west</span>
              </button>
              <button onClick={() => handleScroll('right')} className="p-4 rounded-full bg-slate-800 hover:bg-slate-700 transition-colors">
                <span className="material-symbols-outlined">east</span>
              </button>
            </div>
          </div>
          
          <div ref={scrollContainerRef} className="flex gap-6 overflow-x-auto no-scrollbar snap-x snap-mandatory pb-8">
            <div className="flex-shrink-0 w-[85vw] md:w-[400px] bg-slate-800/50 backdrop-blur-md border border-slate-700 p-8 rounded-3xl snap-start reveal">
              <div className="h-48 rounded-2xl overflow-hidden mb-6 bg-slate-700">
                 <img alt="Sachet Water" className="w-full h-full object-cover" src="/assets/sachet_water.png"/>
              </div>
              <div className="inline-block px-3 py-1 bg-slate-700 text-xs font-bold rounded-lg mb-4 text-blue-300">Fast & Easy</div>
              <h4 className="text-2xl font-bold mb-2">Sachet Water</h4>
              <p className="text-slate-400">The quickest way to hydrate on the go. Delivered in pure, verified sachets.</p>
            </div>
            
            <div className="flex-shrink-0 w-[85vw] md:w-[400px] bg-slate-800/50 backdrop-blur-md border border-slate-700 p-8 rounded-3xl snap-start reveal" style={{transitionDelay: '0.1s'}}>
              <div className="h-48 rounded-2xl overflow-hidden mb-6 bg-slate-700">
                 <img alt="Bottled Water" className="w-full h-full object-cover" src="/assets/bottled_water.png"/>
              </div>
              <div className="inline-block px-3 py-1 bg-slate-700 text-xs font-bold rounded-lg mb-4 text-blue-300">Quick Grab</div>
              <h4 className="text-2xl font-bold mb-2">Bottled Water</h4>
              <p className="text-slate-400">Perfect for the fridge, the gym, or the office desk. Get crisp packs delivered instantly.</p>
            </div>

            <div className="flex-shrink-0 w-[85vw] md:w-[400px] bg-primary/20 backdrop-blur-md border border-primary/30 p-8 rounded-3xl snap-start reveal" style={{transitionDelay: '0.2s'}}>
              <div className="h-48 rounded-2xl overflow-hidden mb-6 bg-slate-700 relative">
                 <img alt="Dispenser Refills" className="w-full h-full object-cover" src="/assets/dispenser_water.png"/>
              </div>
              <div className="inline-block px-3 py-1 bg-primary text-xs font-bold rounded-lg mb-4 text-white">Most Popular</div>
              <h4 className="text-2xl font-bold mb-2">Dispenser Refills</h4>
              <p className="text-slate-200">The 19L classic. Schedule recurring deliveries so you never see the bottom of the bottle.</p>
            </div>

            <div className="flex-shrink-0 w-[85vw] md:w-[400px] bg-slate-800/50 backdrop-blur-md border border-slate-700 p-8 rounded-3xl snap-start reveal" style={{transitionDelay: '0.3s'}}>
              <div className="h-48 rounded-2xl overflow-hidden mb-6 bg-slate-700">
                 <img alt="Bulk Water Tanker" className="w-full h-full object-cover" src="/assets/tanker_water.png"/>
              </div>
              <div className="inline-block px-3 py-1 bg-slate-700 text-xs font-bold rounded-lg mb-4 text-orange-300">Bulk Needs</div>
              <h4 className="text-2xl font-bold mb-2">Tankers</h4>
              <p className="text-slate-400">High-volume supply for estates, factories, or large events. Reliable and tested.</p>
            </div>
          </div>
        </div>
      </section>

      {/* For Sellers / Infrastructure */}
      <section id="sellers" className="py-32 bg-slate-50 relative">
        <div className="max-w-7xl mx-auto px-6">
          <div className="bg-white rounded-[3rem] overflow-hidden flex flex-col md:flex-row shadow-clinical border border-slate-100">
            <div className="md:w-1/2 p-12 md:p-20 flex flex-col justify-center space-y-8 reveal">
              <div className="w-16 h-16 bg-orange-100 text-[#F97316] rounded-2xl flex items-center justify-center blob-shape">
                <span className="material-symbols-outlined text-3xl">trending_up</span>
              </div>
              <h3 className="text-4xl md:text-5xl font-headline font-extrabold text-slate-900 tracking-tight">Grow Your Water Business on Autopilot.</h3>
              <p className="text-slate-600 text-lg leading-relaxed">
                Ditch the chaotic WhatsApp orders. Join hundreds of vendors reaching more customers with our smart fleet routing and automated payouts.
              </p>
              
              <ul className="space-y-4">
                {[
                  'Get discovered by thousands of buyers near you.',
                  'Track your riders on a live map.',
                  'Secure, instant wallet payouts.',
                  'Analytics to know your best customers.'
                ].map((item, i) => (
                  <li key={i} className="flex items-center gap-3 font-medium text-slate-700">
                    <span className="material-symbols-outlined text-primary">check_circle</span>
                    {item}
                  </li>
                ))}
              </ul>

              <div className="pt-6">
                <button onClick={() => setModal(true)} className="bg-slate-900 text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-slate-800 transition-colors shadow-xl">
                  Register as a Seller
                </button>
              </div>
            </div>
            <div className="md:w-1/2 bg-blue-50 relative min-h-[400px] flex items-center justify-center overflow-hidden reveal" style={{ transitionDelay: '0.2s' }}>
               <div className="absolute w-[800px] h-[800px] border border-blue-200 rounded-full animate-[spin_60s_linear_infinite]"></div>
               <div className="absolute w-[600px] h-[600px] border border-blue-300 rounded-full animate-[spin_40s_linear_infinite_reverse]"></div>
               <img alt="Seller Dashboard" className="relative z-10 w-3/4 rounded-3xl shadow-2xl skew-y-3 hover:skew-y-0 transition-transform duration-500" src="https://storage.googleapis.com/wota_public/screen.png"/>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-24 bg-white overflow-hidden">
        <div className="max-w-7xl mx-auto px-6 mb-16 text-center reveal">
          <h3 className="text-4xl md:text-5xl font-headline font-extrabold text-slate-900 tracking-tight mb-4">Don't Just Take Our Word For It.</h3>
          <p className="text-slate-500 text-lg">See what our users are saying about the WOTA experience.</p>
        </div>

        <div className="mb-8 relative flex overflow-x-hidden group">
          <div className="animate-marquee whitespace-nowrap">
            {[...buyerTestimonials, ...buyerTestimonials].map((item, idx) => (
              <div key={idx} className="bg-slate-50 hover:bg-white p-8 rounded-3xl shadow-sm hover:shadow-clinical border border-slate-100 mx-4 w-[350px] inline-block whitespace-normal transition-all duration-300">
                <div className="flex text-yellow-400 mb-4 gap-1">
                  {[...Array(5)].map((_, i) => (
                    <span key={i} className="material-symbols-outlined" style={{ fontVariationSettings: "'FILL' 1" }}>star</span>
                  ))}
                </div>
                <p className="text-slate-700 font-medium leading-relaxed mb-6">"{item.text}"</p>
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center font-bold text-primary blob-shape">{item.author[0]}</div>
                  <div>
                    <div className="font-bold text-slate-900">{item.author}</div>
                    <div className="text-xs text-slate-500">{item.location}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        
        <div className="relative flex overflow-x-hidden group">
          <div className="animate-marquee-reverse whitespace-nowrap">
            {[...producerTestimonials, ...producerTestimonials].map((item, idx) => (
              <div key={idx} className="bg-slate-900 p-8 rounded-3xl shadow-lg border border-slate-800 mx-4 w-[400px] inline-block whitespace-normal hover:bg-slate-800 transition-colors">
                 <div className="flex items-center gap-2 mb-4">
                  <span className="material-symbols-outlined text-primary" style={{ fontVariationSettings: "'FILL' 1" }}>verified</span>
                  <span className="text-xs font-bold text-blue-400 uppercase tracking-widest">Verified Vendor</span>
                </div>
                <p className="text-slate-300 font-medium leading-relaxed mb-6">"{item.text}"</p>
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center font-bold text-white blob-shape">{item.author[0]}</div>
                  <div>
                    <div className="font-bold text-white">{item.author}</div>
                    <div className="text-xs text-slate-400">{item.company}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-32 bg-primary relative overflow-hidden text-center">
        <div className="absolute inset-0 bg-[url('https://storage.googleapis.com/wota_public/app_shot1.jpg')] bg-cover bg-center opacity-10 mix-blend-overlay"></div>
        <div className="absolute top-0 right-0 w-full h-full bg-gradient-to-b from-primary/50 to-primary"></div>
        <div className="max-w-3xl mx-auto px-6 space-y-10 relative z-10 reveal">
          <h2 className="text-5xl md:text-7xl font-headline font-extrabold text-white tracking-tight leading-tight">Ready to Drink Better?</h2>
          <p className="text-blue-100 text-xl font-medium">Join the fast-growing community making water delivery seamless.</p>
          <div className="flex flex-col sm:flex-row justify-center gap-6">
             <button onClick={() => setStoreModal(true)} className="bg-white text-primary px-10 py-5 rounded-full font-bold text-xl hover:shadow-2xl hover:-translate-y-1 transition-all">
                Download the App
             </button>
          </div>
        </div>
      </section>
    </main>
  );

  const renderView = () => {
    switch (nav) {
      case "home":
        return <Home />;
      case "tandc":
        return (
          <div className="pt-32 pb-20 px-6 max-w-4xl mx-auto">
             <TandC />
          </div>
        );
      case "pandp":
        return (
          <div className="pt-32 pb-20 px-6 max-w-4xl mx-auto">
            <PandP />
          </div>
        );
      default:
        return <Home />;
    }
  };

  return (
    <div className="bg-white text-slate-900 font-body selection:bg-primary/20 selection:text-primary min-h-screen">
      <Header />
      <Modal modal={modal} setModal={setModal} />
      <StoreModal modal={storeModal} setModal={setStoreModal} />
      {loading ? (
        <div className="flex min-h-screen w-full items-center justify-center bg-white">
          <div className="relative">
            <div className="animate-spin rounded-[40%_60%] h-24 w-24 border-[3px] border-primary border-t-transparent shadow-lg"></div>
            <div className="absolute inset-0 flex items-center justify-center">
              <span className="material-symbols-outlined text-primary animate-pulse text-3xl">water_drop</span>
            </div>
          </div>
        </div>
      ) : (
        renderView()
      )}
      <Footer />
    </div>
  );
}
